/* eslint-disable */
export default {
  Inbound: 'Entrada',
  Outbound: 'Saída',
  log: 'Log',
  save: 'Salvar e abrir nova',
  discard: 'Descartar e abrir nova',
  hangup: 'Desligar',
  reject: 'Para caixa postal',
  saveDraftAndCreateNewLog: 'Salvar rascunho e criar novo log de chamadas',
} as const;

// @key: @#@"Inbound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"Outbound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save and new"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard and new"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hangup"@#@
// @key: @#@"reject"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"saveDraftAndCreateNewLog"@#@ @source: @#@"Save draft and create new call log"@#@
